// ADDED
import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Input, CheckInput } from "../../../../../common/Input";

const ClinicRequirementsAddEditModal = ({ isOpen, onClose, selectedItem, onSave }) => {
  const [form, setForm] = useState({
    description: "",
    isActive: true,
  });

  useEffect(() => {
    if (selectedItem) {
      setForm({ ...selectedItem });
    } else {
      setForm({ description: "", isActive: true });
    }
  }, [selectedItem, isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3" style={{ marginTop: "0px" }}>
      <div className="bg-white w-full md:w-[450px] rounded-lg shadow-xl flex flex-col">
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-xl font-bold">{selectedItem ? "Edit" : "Add"} Requirement</h2>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer"><CloseIcon /></button>
        </div>

        <div className="p-6 space-y-6">
          <Input
            label="Description"
            placeholder="e.g., Medical Certificate, X-Ray"
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
            isRequired
          />

          <CheckInput
            name="Active"
            value={form.isActive}
            onChange={(val) => setForm({ ...form, isActive: val })}
            isEditMode={true}
          />
        </div>

        <div className="flex justify-end space-x-2 p-5 border-t">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded border-none cursor-pointer">Cancel</button>
          <button
            onClick={() => onSave(form)}
            disabled={!form.description}
            className={`px-6 py-2 rounded border-none cursor-pointer text-white ${!form.description ? 'bg-blue-300' : 'bg-blue-600'}`}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClinicRequirementsAddEditModal;